import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import { LocalizedDatePipe } from './pipes/localized-date-pipe';
import { TransferStatusBadgeComponent } from './components/transfer-status-badge/transfer-status-badge.component';
import { IonicModule } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../app.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DriverInstructionsComponent } from './components/driver-instructions/driver-instructions.component';
import { OpeningHoursModalComponent } from './components/opening-hours-modal/opening-hours-modal.component';
import { StationDetailsComponent } from './components/station-details/station-details.component';
import { ReceiptDetailModalComponent } from './components/receipt-detail-modal/receipt-detail-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AddressInputModalComponent } from './components/address-input-modal/address-input-modal.component';
import { TransferWarningStatusBadgeComponent } from './components/transfer-warning-status-badge/transfer-warning-status-badge.component';
import { PdfModalComponent } from './components/pdf-modal/pdf-modal.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NetworkStateComponent } from './components/network-state/network-state.component';
import { UpdateRequestModalComponent } from './components/update-request-modal/update-request-modal.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ForbiddenBrowserModalComponent } from './components/forbidden-browser-modal/forbidden-browser-modal.component';
import { OnboardingRequestModalComponent } from './components/onboarding-request-modal/onboarding-request-modal.component';
import { ObjectToKeysPipe } from './pipes/object-to-keys.pipe';
import { FormatOpeningHoursPipe } from './pipes/format-opening-hours.pipe';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { MobileOnlyComponent } from './components/mobile-only/mobile-only.component';
import { PlannedPickupTimeAlertComponent } from './components/planned-pickup-time-alert/planned-pickup-time-alert.component';
import { QualityBonusStatusComponent } from './components/quality-bonus-status/quality-bonus-status.component';
import { StatusBonusPanelComponent } from './components/status-bonus-panel/status-bonus-panel.component';
import { TimeSlotPickerComponent } from './components/time-slot-picker/time-slot-picker.component';
import { FormsModule } from '@angular/forms';
import { CapabilitiesCardComponent } from './components/capabilities-card/capabilities-card.component';
import { AddressCardComponent } from './components/address-card/address-card.component';
import { InfoModalComponent } from './components/info-modal/info-modal.component';
import { SelectSearchPopoverComponent } from './components/select-search-popover/select-search-popover.component';
import { SelectItemComponent } from './components/select-search-popover/components/select-item/select-item.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ScanDocumentModalComponent } from './components/scan-document-modal/scan-document-modal.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';

registerLocaleData(localeDE);

@NgModule({
  declarations: [
    SafeUrlPipe,
    TransferStatusBadgeComponent,
    DriverInstructionsComponent,
    OpeningHoursModalComponent,
    StationDetailsComponent,
    ReceiptDetailModalComponent,
    AddressInputModalComponent,
    TransferWarningStatusBadgeComponent,
    PdfModalComponent,
    NetworkStateComponent,
    UpdateRequestModalComponent,
    OnboardingRequestModalComponent,
    ForbiddenBrowserModalComponent,
    ObjectToKeysPipe,
    FormatOpeningHoursPipe,
    SignaturePadComponent,
    MobileOnlyComponent,
    PlannedPickupTimeAlertComponent,
    QualityBonusStatusComponent,
    StatusBonusPanelComponent,
    TimeSlotPickerComponent,
    CapabilitiesCardComponent,
    AddressCardComponent,
    InfoModalComponent,
    ScanDocumentModalComponent,
    DocumentViewerComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
    ImageCropperComponent,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    HttpClientModule,
    LocalizedDatePipe,
    SelectSearchPopoverComponent,
    SelectItemComponent,
  ],
  exports: [
    LocalizedDatePipe,
    SafeUrlPipe,
    TransferStatusBadgeComponent,
    DriverInstructionsComponent,
    OpeningHoursModalComponent,
    StationDetailsComponent,
    ReceiptDetailModalComponent,
    AddressInputModalComponent,
    TransferWarningStatusBadgeComponent,
    PdfModalComponent,
    NetworkStateComponent,
    UpdateRequestModalComponent,
    OnboardingRequestModalComponent,
    ForbiddenBrowserModalComponent,
    ObjectToKeysPipe,
    FormatOpeningHoursPipe,
    SignaturePadComponent,
    MobileOnlyComponent,
    PlannedPickupTimeAlertComponent,
    QualityBonusStatusComponent,
    StatusBonusPanelComponent,
    TimeSlotPickerComponent,
    CapabilitiesCardComponent,
    AddressCardComponent,
    InfoModalComponent,
    ScanDocumentModalComponent,
    DocumentViewerComponent,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'de' }, LocalizedDatePipe],
})
export class SharedModule {}
